var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { IdentifiableMap } from "../collections";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { CustomParameterInstanceFactory, Menu, ModifierInstanceAvailabilityService, ModifierInstanceFactory, ProductConfig, ProductInstance, ProductInstanceHalves, ProductInstancePart, PurchaseOrderScope, SingleProductInstancePart, } from "../ordering";
import { MenuSectionItemScope } from "./MenuSectionItemScope";
let VariantCreatorFactory = class VariantCreatorFactory {
    constructor(menu, purchaseOrderScope, customParameterInstanceFactoy, modifierInstanceFactory, modifierInstanceAvailabilityService) {
        this.menu = menu;
        this.purchaseOrderScope = purchaseOrderScope;
        this.customParameterInstanceFactoy = customParameterInstanceFactoy;
        this.modifierInstanceFactory = modifierInstanceFactory;
        this.modifierInstanceAvailabilityService = modifierInstanceAvailabilityService;
        makeImmutable(this);
    }
    createProductInstance(variant) {
        const customParameterInstances = this.customParameterInstanceFactoy.fromCustomParameterSet(variant.customParameterChoices);
        const menuSectionItemScope = new MenuSectionItemScope({
            parentScope: this.purchaseOrderScope,
            selfCustomParameterSet: variant.customParameterChoices,
        });
        const { true: divisibleParameterInstances, false: nonDivisibleParameterInstances, } = customParameterInstances.partition((customParameterInstance) => customParameterInstance.customParameterType.isDivisible);
        const partsConfig = new ProductConfig({
            modifierInstances: IdentifiableMap.empty(),
            customParameterInstances: divisibleParameterInstances,
        });
        const parts = this.creatorParts(variant.productTypes, partsConfig, menuSectionItemScope);
        if (parts === null) {
            return null;
        }
        const commonConfig = new ProductConfig({
            modifierInstances: parts.type === "SinglePart"
                ? this.irremovableModifierInstances(parts.part.productType, menuSectionItemScope)
                : IdentifiableMap.empty(),
            customParameterInstances: nonDivisibleParameterInstances,
        });
        return new ProductInstance({
            commonConfig,
            parts,
        });
    }
    irremovableModifierInstances(productType, scope) {
        // NOTICE Include default irremovable nondivisible modifiers in menu prices
        return IdentifiableMap.fromIterable("typeId", productType.nonDivisibleModifierTypes.objects.mapOptional((modifierType) => {
            if (modifierType.exchangePolicy === "NotIncluded" &&
                modifierType.isFiscalizedSeparately) {
                const modifierSettings = productType.modifierSettings(modifierType);
                const itemQuantities = modifierSettings.defaultItems.filterWithKey((modifierItemType) => modifierType.itemType(modifierItemType).irremovable);
                if (itemQuantities.values.every((value) => value.isZero)) {
                    return null;
                }
                const instance = this.modifierInstanceFactory.create({
                    modifierType,
                    modifierSettings,
                    itemQuantities,
                    scope,
                });
                if (this.modifierInstanceAvailabilityService.availability(instance)
                    .isAvailable.isPossible) {
                    return instance;
                }
                return null;
            }
            return null;
        }));
    }
    creatorParts(productTypes, partsConfig, menuSectionItemScope) {
        switch (productTypes.type) {
            case "Single":
                return new SingleProductInstancePart(new ProductInstancePart({
                    scope: menuSectionItemScope,
                    productType: productTypes.productType,
                    productConfig: partsConfig,
                }));
            case "Halves":
                return ProductInstanceHalves.create({
                    scope: menuSectionItemScope,
                    productCategory: this.menu.productCategories.get(productTypes.first.productCategoryId),
                    first: new ProductInstancePart({
                        scope: menuSectionItemScope,
                        productType: productTypes.first,
                        productConfig: partsConfig,
                    }),
                    second: new ProductInstancePart({
                        scope: menuSectionItemScope,
                        productType: productTypes.second,
                        productConfig: partsConfig,
                    }),
                });
        }
    }
};
VariantCreatorFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof Menu !== "undefined" && Menu) === "function" ? _a : Object, typeof (_b = typeof PurchaseOrderScope !== "undefined" && PurchaseOrderScope) === "function" ? _b : Object, typeof (_c = typeof CustomParameterInstanceFactory !== "undefined" && CustomParameterInstanceFactory) === "function" ? _c : Object, typeof (_d = typeof ModifierInstanceFactory !== "undefined" && ModifierInstanceFactory) === "function" ? _d : Object, typeof (_e = typeof ModifierInstanceAvailabilityService !== "undefined" && ModifierInstanceAvailabilityService) === "function" ? _e : Object])
], VariantCreatorFactory);
export { VariantCreatorFactory };
